import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Box,
    Button,
    Paper,
    CircularProgress,
    MenuItem
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import {
    Insert as PRODUCT_BOOK,
    Select as BOOK_SELECT_ALL
} from 'Components/Api/OfflineBookingAPI';
import {
    SelectPackageName as SELECT_PACKAGE_NAME,
    SelectByOfflineProductMasterID as SELECT_PRODUCT_DETAIL
} from 'Components/Api/OfflineProductAPI';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import { ViewChannel } from 'Pages/InnerPages/DthPackageChannelMapping/ViewChannel';
import { CustomModal } from 'Components/Modal/CustomModal';
import ReactTable from 'Components/ReactTable/ReactTable';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID,
    DTH_BOOKING
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
const CustomContainer = HOCLoader(Container);

export const OfflineBook = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const [itemList, setItemList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [IsDisplayCriteria, setIsDisplayCriteria] = useState(false);
    const [Operator, setOperator] = useState([]);
    const [Package, setPackage] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [ischannelOpen, setischannelOpen] = useState(false);

    const selectData = async () => {
        const response = await BOOK_SELECT_ALL();
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }
        var data = JSON.parse(response.data);
        setItemList(data);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'OfflineProductMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'Date'
        });

        columns.push({
            label: 'FirmName',
            name: 'FirmName'
        });

        columns.push({
            label: 'Operator',
            name: 'OperatorName'
        });

        columns.push({
            label: 'PackageName',
            name: 'PackageName'
        });

        columns.push({
            label: 'Booking Name',
            name: 'PersonName'
        });
        columns.push({
            label: 'Contact',
            name: 'ConsumerNumber'
        });
        columns.push({
            label: 'Address',
            name: 'Address'
        });
        columns.push({
            label: 'Pincode',
            name: 'Pincode'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            numeric: true
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'Desc',
            name: 'Description'
        });
        setMainColumns(columns);
    };

    useEffect(() => {
        setLoadingOpen(true);
        createColumns();
        selectData();
    }, []);

    const OnPackageChange = async (name, value, setFieldValue) => {
        var OperatorID = value; //event.target.value;
        setFieldValue(name, value);
        selectPackageName(OperatorID);
    };
    const selectPackageName = async (OperatorID) => {
        if (
            OperatorID === null ||
            OperatorID === undefined ||
            OperatorID === 0 ||
            OperatorID === '0'
        )
            return;

        var requestObj = {
            OpType: formRef.current.values.OpType,
            OperatorID: OperatorID
        };
        var request = JSON.stringify(requestObj);
        const response = await SELECT_PACKAGE_NAME(request);
        if (!response.isAuthorized) LOGOUT();
        var data = JSON.parse(response.data);

        setPackage(data);
    };
    const OnOperatorChange = async (name, value, setFieldValue) => {
        //var OfflineServiceMasterID = value; //event.target.value;
        setFieldValue(name, value);
        selectOperator(DTH_BOOKING);
    };

    const selectOperator = async (ServiceID) => {
        if (ServiceID === null || ServiceID === undefined || ServiceID === 0)
            return;

        var requestObj = {
            ServiceID: ServiceID
        };
        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };
    const OnDetailChange = async (name, value, setFieldValue) => {
        var OfflineProductMasterID = value; //event.target.value;
        setFieldValue(name, value);
        selectProductDetail(OfflineProductMasterID);
    };
    const selectProductDetail = async (OfflineProductMasterID) => {
        let JSONObj = {
            OfflineProductMasterID: OfflineProductMasterID
        };
        var request = JSON.stringify(JSONObj);

        const response = await SELECT_PRODUCT_DETAIL(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        var data = JSON.parse(response.data);
        setFormObject({
            ...formObject,
            PackageMRP: data.PackageMRP,
            BookingAmount: data.BookingAmount,
            Validity: data.Validity,
            Description: data.Description,
            OfflineProductMasterID: data.OfflineProductMasterID,
            OperatorID: formRef.current.values.OperatorID,
            OpType: formRef.current.values.OpType,
            Name: data.Name
        });
        setIsDisplayCriteria(true);
    };

    const [formObject, setFormObject] = useState({
        ServiceID: DTH_BOOKING,
        OpType: '0',
        OperatorID: '0',
        ConsumerNumber: '',
        PackageMRP: '0',
        BookingAmount: '',
        Validity: '',
        Description: '',
        OfflineProductMasterID: '0',
        Address: '',
        PersonName: '',
        Name: '',
        IsChannelButton: false,
        Through: 'Web',
        Pincode: ''
    });

    const FormValidationSchema = Yup.object({
        OpType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'OpType')
            .required(PLEASE_SELECT_VALID + 'OpType'),

        OperatorID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator'),

        OfflineProductMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'Package')
            .required(PLEASE_SELECT_VALID + 'Package'),

        ConsumerNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),

        PersonName: Yup.string().required(PLEASE_PROVIDE_VALID + 'Person Name'),

        Address: Yup.string().required(PLEASE_PROVIDE_VALID + 'Address'),

        Pincode: Yup.string()
            .length(6, 'Must be 6 digit')
            .required(PLEASE_PROVIDE_VALID + 'Pincode')
    });

    const submithandle = async (values, { resetForm }) => {
        if (values.IsChannelButton) {
            setischannelOpen(true);
            return;
        }
        let op = Operator.filter((o) => o.OperatorID === values.OperatorID);
        values.OperatorName = op[0].OperatorName;
        let pg = Package.filter(
            (o) => o.OfflineProductMasterID === values.OfflineProductMasterID
        );
        values.Name = pg[0].Name;

        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
    };

    const Booking = async (values) => {
        if (loadingOpen) {
            setLoadingOpen(false);
            return;
        }
        var requestObj = JSON.stringify(values);

        setIsError(false);
        setLoadingOpen(true);
        var response = await PRODUCT_BOOK(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setResponseMessage(response.data);
        setIsError(true);

        setSeverity('success');
        if (!response.status) {
            setSeverity('error');
            return;
        }

        setFormObject({
            OperatorID: 0,
            OfflineProductMasterID: 0,
            ConsumerNumber: '',
            PackageMRP: '',
            BookingAmount: '',
            Validity: '',
            Description: '',
            Address: '',
            PersonName: '',
            Pincode: '',
            Name: '',
            OpType: 0
        });
        setIsDisplayCriteria(false);
        selectData();
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={10} lg={10}>
                                    <h2 className={classes.PaperHead_h2}>
                                        Offline Booking
                                    </h2>
                                </Grid>
                                <Grid item xs={12} sm={12} md={2} lg={2}>
                                    <h2 className={classes.PaperHead_h2}>
                                        {IsDisplayCriteria ? (
                                            <PrimaryButton
                                                variant="contained"
                                                color="primary"
                                                title=" View Channel"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                onClick={() => {
                                                    setischannelOpen(true);
                                                }}
                                            >
                                                View Channel
                                            </PrimaryButton>
                                        ) : null}
                                    </h2>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="OpType"
                                                name="OpType"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    OnOperatorChange(
                                                        name,
                                                        value,
                                                        setFieldValue
                                                    );
                                                }}
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select OpType
                                                </MenuItem>

                                                <MenuItem
                                                    key="SD BOX"
                                                    value="SD BOX"
                                                >
                                                    SD BOX
                                                </MenuItem>
                                                <MenuItem
                                                    key="HD BOX"
                                                    value="HD BOX"
                                                >
                                                    HD BOX
                                                </MenuItem>
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Operator"
                                                name="OperatorID"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    OnPackageChange(
                                                        name,
                                                        value,
                                                        setFieldValue
                                                    );
                                                }}
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Operator
                                                </MenuItem>
                                                {Operator.map((Item) => (
                                                    <MenuItem
                                                        key={Item.OperatorID}
                                                        value={Item.OperatorID}
                                                    >
                                                        {Item.OperatorName}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialSelect
                                                label="Package Name"
                                                name="OfflineProductMasterID"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    OnDetailChange(
                                                        name,
                                                        value,
                                                        setFieldValue
                                                    );
                                                }}
                                            >
                                                <MenuItem key="0" value="0">
                                                    select Package
                                                </MenuItem>
                                                {Package.map((Item) => (
                                                    <MenuItem
                                                        key={
                                                            Item.OfflineProductMasterID
                                                        }
                                                        value={
                                                            Item.OfflineProductMasterID
                                                        }
                                                    >
                                                        {Item.Name}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Package MRP"
                                                name="PackageMRP"
                                                type="text"
                                                length={7}
                                                placeholder="Package MRP"
                                                readOnly={true}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Booking Amount"
                                                name="BookingAmount"
                                                type="text"
                                                length={7}
                                                placeholder="Booking Amount"
                                                readOnly={true}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Description"
                                                name="Description"
                                                type="text"
                                                placeholder="Description"
                                                readOnly={true}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Validity(In Day)"
                                                name="Validity"
                                                type="text"
                                                placeholder="Validity (In Day)"
                                                readOnly={true}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Contact Number"
                                                name="ConsumerNumber"
                                                type="text"
                                                length={10}
                                                placeholder="Contact Number"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Person Name"
                                                name="PersonName"
                                                placeholder="Person Name"
                                                title="Person Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Address"
                                                name="Address"
                                                placeholder="Address"
                                                title="Address"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialNumberField
                                                label="Pincode"
                                                name="Pincode"
                                                length={6}
                                                placeholder="Pincode"
                                                title="Pincode"
                                            />
                                        </Grid>

                                        {/* <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <PrimaryButton
                                                variant="contained"
                                                color="primary"
                                                title="Search"
                                                endIcon={<SearchIcon />}
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                onClick={() => {
                                                    FetchDetails(values);
                                                }}
                                                style={{ marginLeft: '10px' }}
                                            ></PrimaryButton>
                                        </Grid> */}
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Book"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'IsChannelButton',
                                                    false
                                                );
                                            }}
                                        >
                                            Book
                                        </Button>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            <ReactTable data={itemList} columns={mainColumns} />

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Booking"
                    message="Are you sure to do book?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Booking(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {ischannelOpen ? (
                <CustomModal
                    isOpen={ischannelOpen}
                    title={'Package : ' + formObject.Name}
                    width="75%"
                    onDismissCallback={(value) => {
                        setischannelOpen(value);
                    }}
                >
                    <ViewChannel
                        OfflineProductMasterID={
                            formObject.OfflineProductMasterID
                        }
                        onDismissCallback={(value) => {
                            setischannelOpen(value);
                        }}
                    />
                </CustomModal>
            ) : null}
        </CustomContainer>
    );
};
